import React from "react";
import { Container, Button, Alert } from "react-bootstrap";
import Header from "../../components/header";
import { logError } from "../../utils/errorTracker";
import "../../App.css";

const TestErrorsPage = () => {
  const generateTestErrors = async () => {
    try {
      // Test API Error
      await logError("TestComponent", "API_ERROR", "Test API error message", {
        apiUrl: "/api/test-endpoint",
        userId: "test-user-123",
        email: "test@example.com",
      });

      // Test Network Error
      await logError(
        "TestComponent",
        "NETWORK_ERROR",
        "Test network error message",
        {
          url: "/test-resource",
          statusCode: 404,
        }
      );

      // Test Validation Error
      await logError(
        "TestComponent",
        "VALIDATION_ERROR",
        "Test validation error message",
        {
          field: "email",
          value: "invalid-email",
        }
      );

      // Test Auth Error
      await logError(
        "TestComponent",
        "AUTH_ERROR",
        "Test authentication error message",
        {
          userId: "test-user-123",
          action: "login",
        }
      );

      // Test DOM Error
      await logError("TestComponent", "DOM_ERROR", "Test DOM error message", {
        element: "button",
        action: "click",
      });

      alert(
        "5 test errors have been generated! Check the /errors page to see them."
      );
    } catch (error) {
      console.error(
        "❌ TestErrorsPage: Failed to generate test errors:",
        error
      );
      alert("Failed to generate test errors. Check console for details.");
    }
  };

  return (
    <>
      <Header />
      <Container className="mainPage">
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <h1>Error Tracking Test</h1>
          <Alert variant="info">
            <Alert.Heading>Test Error Generation</Alert.Heading>
            <p>
              Click the button below to generate 5 test errors of different
              types. Then visit the <a href="/errors">/errors</a> page to see
              them in the error log.
            </p>
          </Alert>

          <Button
            variant="primary"
            size="lg"
            onClick={generateTestErrors}
            style={{ marginTop: "1rem" }}
          >
            Generate Test Errors
          </Button>

          <div style={{ marginTop: "2rem" }}>
            <Button variant="outline-secondary" href="/errors">
              View Error Log
            </Button>
          </div>
        </div>
      </Container>
    </>
  );
};

export default TestErrorsPage;
